import React, { useState, useEffect } from "react";
import Button from "@components/Button";
import CustomInput, { CustomSelectInput } from "@components/CustomInput/CustomInput";
import { Home } from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router";
import styles from "./ViewHistoryPage.module.css";
import HistoryTable from "@components/HistoryTable/HistoryTable";
import PostPayDoctorCard from "@components/PostPayDoctorCard/PostPayDoctorCard";
import { Avatar } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useSelector } from "react-redux";
import usePostPay from "@hooks/usePostPay";

const ViewHistoryPage = () => {
    const navigate = useNavigate();
    const { handlePaymentHistory } = usePostPay();
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = useState(0);
    const { paymentHistory } = useSelector((state) => state.postpay);
    const location = useLocation();
    const {doctor} = location.state || {};

    useEffect(() => {
        handlePaymentHistory({
            doctor_id: doctor._id,
            page: page + 1,
            limit: rowsPerPage
        });
    }, [page, rowsPerPage]);

    const handleNavigateDashboard = () => {
        navigate("/");
    };

    const handleManagePostPayPage = () => {
        navigate("/managepostpay");
    };

    const handleNavigateUpgradeAccessPage = () => {
        navigate("/managepostpay/upgradeaccess");
    };

    const handleNavigateViewUserPage = () => {
        navigate(`/managepostpay/viewuser/${doctor.myReferenceNumber}`,{
            state:{doctor:doctor}
        });
    };

    const columns = [
        { id: "date", label: "Date" },
        { id: "amount", label: "Amount" },
        { id: "mode", label: "Mode" },
        { id: "proof", label: "Proof" },
        { id: "comment", label: "Comment" },
        { id: "approver", label: "Approver" },
    ];
    
    const createData = (date, amount, mode, proof, comment, approver) => {
        const formattedDate = new Date(date).toLocaleDateString("en-GB");
        return {
          date: formattedDate,
          amount: parseFloat(amount.$numberDecimal),
          mode,  
          proof,
          comment,
          approver
        };
      };
    
    const rows = Array.isArray(paymentHistory?.data) 
    ? paymentHistory.data.flatMap((doctor) =>
        Array.isArray(doctor.payment) 
            ? doctor.payment.map((pay) =>
                createData(
                    pay.date, 
                    pay.amount, 
                    pay.mode, 
                    pay.proofUri,
                    pay.comment,
                    pay.aproovedBy
                )
              ) 
            : []
      )
    : [];

    return (
        <>
            <div className={styles.MenuWrapper}>
                <div className={styles.NavigationWrapper}>
                    <Home className={styles.HomeIcon} onClick={handleNavigateDashboard} />{" "}
                    <div>
                        <span className={styles.DashboardText} onClick={handleNavigateDashboard}>
                            Dashboard
                        </span>
                        <span className={styles.DashboardText} onClick={handleManagePostPayPage}>
                            /PostPay Panel
                        </span>
                        <span className={styles.RouteText} >/View History</span>
                    </div>
                </div>
                <div className={styles.ActionItemsWrapper}>
                    <Button
                        className={styles.BtnClass}
                        text={"View User"}
                        btnType={"secondary"}
                        onClick={handleNavigateViewUserPage}
                    />
                    <Button
                        className={styles.BtnClass}
                        text={"Upgrade Access"}
                        btnType={"secondary"}
                        onClick={handleNavigateUpgradeAccessPage}
                    />
                </div>
            </div>
            <div className={styles.Content}>
                <PostPayDoctorCard 
                  firstName={doctor.local.firstName} 
                  lastName={doctor.local.lastName}
                  gender={doctor.local.gender}
                  contact={doctor.local.contact}
                  email={doctor.local.email}
                  address={doctor.local.address}
                  institute={doctor.local.instituteName}
                  pincode={doctor.local.pincode}
                />
                <div className={styles.divider}></div>
               <div className={styles.history}>
                    <h1>Payment History</h1>
                    { rows.length === 0 ? (
                        <p style={{ fontSize: "12px", display: "flex", justifyContent: "center"}}>No records available</p>
                    ) : (
                        <HistoryTable
                        rows={rows}
                        columns={columns}
                        rowsPerPage={rowsPerPage}
                        setRowsPerPage={setRowsPerPage}
                        page={page}
                        setPage={setPage}
                        totalRecords={paymentHistory?.total_record ?? 0}
                        />
                    )}
                </div>
            </div> 
        </>
    );
};

export default ViewHistoryPage;
